export default class Tabs{
    constructor(element){
        this.element = element

        this.tabs = this.element.querySelectorAll('.tab')
        this.panels = this.element.querySelectorAll('.content')

        this.init()
    }

    init(){
        for(let i = 0; i < this.tabs.length; i++){
            let tab = this.tabs[i]
            tab.addEventListener("click", this.onClick.bind(this))
        }

        /*this.tabs[0].classList.add('active');
        this.panels[0].classList.add('active');*/
    }

    onClick(event){

        for(let i = 0; i < this.tabs.length; i++){
            let tab = this.tabs[i]
            tab.classList.remove('active')
        }

        for(let i = 0; i < this.panels.length; i++){
            let panel = this.panels[i]
            panel.classList.remove('active')
        }

        event.currentTarget.classList.toggle('active')
        let panelComponent = event.currentTarget.innerHTML
        let panelContent = this.element.querySelector(`.content[data-content="${panelComponent}"]`)
        
        panelContent.classList.toggle('active')
    }
}